import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'

import { signIn } from 'features/auth/actions'
import { selectAuthCommunication } from 'features/auth/selectors'

type UseSignInFormProps = {
  onSuccessCallback?: () => void
}

const validationSchema = yup.object().shape({
  username: yup.string().required('required'),
  password: yup.string().required('required'),
})

export const useSignInForm = ({ onSuccessCallback }: UseSignInFormProps) => {
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema,
    onSubmit: values => {
      dispatch(signIn(values, { callback: onSuccessCallback }))
    },
  })
  const { isLoading, isSuccess, error } = useSelector(selectAuthCommunication, shallowEqual).login

  return {
    formik,
    isSuccess,
    error,
    isLoading,
  }
}
